export const priority = {
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3,
};

const ReloadQueue = (() => {
  let currentIntervalId = null;
  let updateTime = 10000; // 10 seconds

  const currentReloadList = [];

  const reloadAll = (dispatch) => {
    currentReloadList.forEach((item) => {
      dispatch(item.action(item.params));
    });
  };


  const removeFromReloadList = (removeList) => {
    removeList.forEach((item) => {
      const index = currentReloadList.findIndex(i => i.name === item.name);
      if (index !== -1) {
        currentReloadList.splice(index, 1);
      }
    });
  };

  const createInterval = (dispatch, time) => {
    // Clear the previous interval if it exists
    if (currentIntervalId) {
      clearInterval(currentIntervalId);
    }
    // Create a new interval
    if (dispatch) {
      const interval = setInterval(() => {
        reloadAll(dispatch);
      }, time);
      currentIntervalId = interval;
      return interval;
    }
    return null;
  };

  const addToReloadList = (dispatch, newList, priorityLevel = 3) => {
    // Add new items to the reload list
    newList.forEach((item) => {
      const found = currentReloadList.find(i => i.name === item.name);
      if (!found) {
        currentReloadList.push({ ...item, priority: priorityLevel });
        dispatch(item.action(item.params));
      } else if (found.priority > priorityLevel) {
        // Update the priority if the new one is higher
        found.priority = priorityLevel;
        currentReloadList.splice(currentReloadList.indexOf(found), 1, found);
        dispatch(item.action(item.params));
      }
    });
    // Recreate the interval with the updated list
    createInterval(dispatch, updateTime);
  };

  const setUpdateTime = (time, dispatch) => {
    if (time > 0) {
      updateTime = time * 1000;
      createInterval(dispatch, updateTime);
    }
  };

  const clearReloadList = (priorityLevel, dispatch) => {
    // Clear the reload list based on priority
    const filteredList = currentReloadList.filter(item => item.priority === priorityLevel);
    filteredList.forEach((item) => {
      const index = currentReloadList.findIndex(i => i.name === item.name);
      if (index !== -1) {
        currentReloadList.splice(index, 1);
      }
    });
    // Recreate the interval with the updated list
    createInterval(dispatch, updateTime);
  };

  const stopReload = () => {
    if (currentIntervalId) {
      clearInterval(currentIntervalId);
      currentIntervalId = null;
    }
  };

  return {
    reloadAll,
    addToReloadList,
    removeFromReloadList,
    createInterval,
    setUpdateTime,
    clearReloadList,
    stopReload,
  };
})();

export default ReloadQueue;
